<div class="container-fluid loginComponent">
  <div class="row d-flex justify-content-center" id="mainRow">
    <div class="col-lg-7 px-0" id="carouselDiv">
      <div
        id="carouselExampleControls"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-pause="false"
        data-bs-interval="4000"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="../../../../assets/images/image1_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image2_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image3_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-lg-5">
      <div class="row">
        <div class="col-12 text-center mb-4-vw" style="margin-top: 10%">
          <!-- <img src="../../../../assets/images/zoei_logo1.png" width="40%" /> -->
          <img
            src="../../../../assets/images/zoei_logo_black.png"
            width="40%"
          />
          <!-- <img
            src="../../../../assets/images/think_gas2.png"
            width="40%"
          /> -->
        </div>
        <!-- <img src="../../../../assets/images/login_logo.png" width="40%" /> -->
        <div
          *ngIf="isResetPasswordEnable"
          class="col-12 d-flex justify-content-center"
        >
          <div class="loginFornt fs-20-vw" style="font-weight: bold">
            Reset Password
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-8 mt-5-vw" *ngIf="!isResetPasswordEnable">
          <form autocomplete="off" [formGroup]="loginForm">
            <label for="username" class="loginFornt fs-16-vw">UserID</label
            ><br />
            <input
              type="text"
              id="username"
              class="w-100 form-control shadow-none fs-14-vw"
              formControlName="username"
              placeholder="Enter username"
              (input)="isFieldTouched = true"
              appDisableAutofill
              [ngClass]="{
                'custom-error':
                  loginForm.get('username')?.invalid &&
                  loginForm.get('username')?.touched
              }"
            /><br />
            <label for="pwd" class="loginFornt fs-16-vw">Password</label><br />
            <div
              class="w-100 passwordDiv fs-14-vw"
              [ngClass]="{
                'custom-error':
                  loginForm.get('password')?.invalid &&
                  loginForm.get('password')?.touched
              }"
            >
              <input
                [type]="!showPassword ? 'password' : 'text'"
                id="pwd"
                class="border-0 form-control shadow-none"
                placeholder="Enter Password"
                formControlName="password"
                name="new-password"
                autocomplete="new-password"
                (input)="isFieldTouched = true"
              />
              <img
                id="passwordIconPic"
                *ngIf="!showPassword"
                src="../../../../assets/images/eye_close_icon.png"
                (click)="showPassword = true"
                alt=""
              />
              <img
                id="passwordIconPic"
                *ngIf="showPassword"
                src="../../../../assets/images/eye_icon.png"
                (click)="showPassword = false"
                alt=""
              />
            </div>

            <br />

            <div
              class="d-flex"
              *ngIf="captchaCurrentUrl !== urlFromWhichCaptchaToRemove"
            >
              <div>
                <input
                  type="text"
                  placeholder="Captcha"
                  formControlName="captcha"
                  class="form-control shadow-none fs-14-vw"
                  (input)="isFieldTouched = true"
                  style="
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                  "
                  [ngClass]="{
                    'custom-error':
                      loginForm.get('captcha')?.invalid &&
                      loginForm.get('captcha')?.touched
                  }"
                />
              </div>

              <div class="mt-2-vw">
                <span
                  class="prefix"
                  style="position: relative; margin-left: -2.222vw"
                  (click)="generateCaptcha()"
                >
                  <img
                    style="width: 1.389vw; height: 1.389vw; cursor: pointer"
                    src="../../../../assets/images/refresh-red.png"
                    alt=""
                /></span>
              </div>

              <div>
                <canvas
                  #myCanvas
                  id="myCanvas"
                  width="110"
                  style="
                    border: 1px solid #d3d3d3;
                    border-bottom-right-radius: 0.694vw;
                    background: #01444b;
                    border-top-right-radius: 0.694vw;
                    height: 2.5vw !important;
                    width: 7.639vw !important;
                  "
                >
                </canvas>
              </div>
            </div>

            <br />
            <label
              class="loginFornt fs-16-vw cursor"
              style="float: right; margin-top: 1%"
              [routerLink]="['/forgetpassword']"
              >Forgot Password ?</label
            >
            <br />
            <button
              class="btn w-100 mt-3-vw loginButton shadow-none fs-16-vw"
              [ngClass]="isFieldTouched ? 'cursor' : 'cursorDisabled'"
              type="submit"
              (click)="isFieldTouched ? login() : ''"
            >
              Login
            </button>
          </form>
        </div>
        <div class="col-8 mt-3-vw mb-2-vw" *ngIf="isResetPasswordEnable">
          <form [formGroup]="changePasswordForm">
            <label for="username" class="loginFornt fs-16-vw"
              >Current Password</label
            ><br />
            <input
              type="password"
              id="username"
              name="username"
              class="w-100 form-control shadow-none fs-14-vw"
              formControlName="currentPassword"
              placeholder="Enter Current Password"
              appDisableAutofill
              (input)="isFieldTouched = true"
            />
            <label for="pwd" class="loginFornt mt-4-vw fs-16-vw"
              >New Password</label
            ><br />
            <div class="w-100 passwordDiv mb-4-vw">
              <input
                [type]="!newPassword ? 'password' : 'text'"
                id="pwd"
                name="pwd"
                class="border-0 form-control shadow-none fs-14-vw"
                placeholder="Enter Password"
                formControlName="newPassword"
                appDisableAutofill
                (input)="checkPasswordStrength(); isFieldTouched = true"
              />
              <img
                id="passwordIconPic"
                *ngIf="!newPassword"
                src="../../../../assets/images/eye_close_icon.png"
                (click)="newPassword = true"
                alt=""
              />
              <img
                id="passwordIconPic"
                *ngIf="newPassword"
                src="../../../../assets/images/eye_icon.png"
                (click)="newPassword = false"
                alt=""
              />
            </div>

            <div class="error-message fs-12-vw">
              <span class="password-instruction-text fw-600"
                >Password should be at least 8 characters and include:</span
              >
              <ul class="list fs-12-vw">
                <li [class.valid]="passwordRules.minLength">
                  At least 8 characters
                </li>
                <li [class.valid]="passwordRules.uppercase">
                  At least 1 uppercase letter
                </li>
                <li [class.valid]="passwordRules.lowercase">
                  At least 1 lowercase letter
                </li>
                <li [class.valid]="passwordRules.number">At least 1 number</li>
                <li [class.valid]="passwordRules.specialChar">
                  At least 1 special character
                </li>
              </ul>
            </div>

            <label for="pwd2" class="loginFornt fs-16-vw"
              >Confirm Password</label
            ><br />
            <div class="w-100 passwordDiv">
              <input
                [type]="!confirmPassword ? 'password' : 'text'"
                id="pwd2"
                name="pwd2"
                class="border-0 form-control shadow-none fs-14-vw"
                placeholder="Enter Password"
                formControlName="confirmPassword"
                appDisableAutofill
                (input)="isFieldTouched = true"
              />
              <img
                id="passwordIconPic"
                *ngIf="!confirmPassword"
                src="../../../../assets/images/eye_close_icon.png"
                (click)="confirmPassword = true"
                alt=""
              />
              <img
                id="passwordIconPic"
                *ngIf="confirmPassword"
                src="../../../../assets/images/eye_icon.png"
                (click)="confirmPassword = false"
                alt=""
              />
            </div>
            <br />
            <button
              class="btn w-100 mt-1 loginButton shadow-none fs-16-vw"
              type="submit"
              (click)="isFieldTouched ? passwordChange() : ''"
              [disabled]="!isFormReadyToSubmit()"
              [ngClass]="isFieldTouched ? 'cursor' : 'cursorDisabled'"
            >
              Submit
            </button>
          </form>
        </div>
        <div class="col-2"></div>
      </div>
    </div>
  </div>
</div>
